import React from "react";

const Hero = () => {
    return (
        <section id="home" className="hero section">
            <div className="stars"></div>
            <div className="container hero-content">
                <h1 className="hero-title">CARY ZHU</h1>
                <h2 className="hero-subtitle">FULL STACK DEVELOPER</h2>
            </div>
        </section>
    );
};

export default Hero;